import { useMutation } from '@apollo/client/react'
import { Loader } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import { BrandLogo } from '~/components/BrandLogo'
import { Button } from '~/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card'
import { GQL_VERIFY_ACCOUNT } from '~/gql/auth/auth'

function ValidAccount() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token')
  const email = searchParams.get('email')

  useEffect(() => {
    if (!token || !email) {
      navigate('/')
    }
  }, [token, email, navigate])

  const [verify, { loading, called: isCalled }] = useMutation(GQL_VERIFY_ACCOUNT)

  const onVerify = async () => {
    try {
      const { data } = await verify({
        variables: {
          email: email!,
          token: token!,
        },
      })
      if (data && data.verifyEmail) {
        toast.success(t('valid.account.success'))
        setTimeout(() => {
          navigate('/')
        }, 2000)
      } else {
        toast.error(t('valid.account.failed'))
      }
    } catch {
      toast.error(t('bad.server-login.message'))
    }
  }

  return (
    <div className="flex w-screen min-h-dvh flex-col items-center justify-center p-5">
      <Card className="sm:w-md w-full">
        <CardHeader className="gap-4">
          <BrandLogo className="h-9 w-auto" fallbackClassName="text-lg" />
          <div className="flex flex-col gap-1">
            <CardTitle className="font-heading text-2xl tracking-tight">{t('account.validate')}</CardTitle>
            <CardDescription>{t('account.validate.confirmation')}</CardDescription>
          </div>
        </CardHeader>
        <CardContent>

          <Button
            type="submit"
            className="w-full"
            disabled={isCalled || loading}
            onClick={onVerify}
          >
            {loading && <Loader className="mr-2 size-4 animate-spin" />}
            {t('common.validate')}
          </Button>

          <div className="mt-4 text-center text-sm">
            <a
              onClick={() => navigate('/')}
              className="underline underline-offset-4 cursor-pointer"
            >
              {t('login.return-message')}
            </a>
          </div>

        </CardContent>
      </Card>
    </div>
  )
}

export default ValidAccount
